import { useState } from "react";
import Port3Graph from "./Port3GraphView";
import "../../css/Port3View.css";
import { useSelector } from "react-redux";
import { Port3UpdatedTime } from "./Port3Slice";

export type PeriodType = "累計" | "今月" | "先月";

const Port3 = () => {
  const [period, setPeriod] = useState<PeriodType>("今月");

  const ChangePeriod = (item: PeriodType) => {
    setPeriod(item);
  };

  const port3UpdatedTime = useSelector(Port3UpdatedTime);

  return (
    <div className="position_row">
      <div className="dashboard_container_port3">
        <h1 className="dashboard_title_port3">
          利用状況 -中区、千種区、昭和区、熱田区、南区- ({period})
        </h1>
        <div className="button_container_port3">
          <button
            className="period_item_port3"
            onClick={() => ChangePeriod("累計")}>
            累計
          </button>
          <button
            className="period_item_port3"
            onClick={() => ChangePeriod("今月")}>
            今月
          </button>
          <button
            className="period_item_port3"
            onClick={() => ChangePeriod("先月")}>
            先月
          </button>
        </div>
        <div className="time_msg">※データは1分ごとに自動更新されます</div>
        <div className="dashbaord_time">最終更新時間 : {port3UpdatedTime}</div>
        <div className="graph_container_port3">
          <Port3Graph period={period} />
        </div>
      </div>
    </div>
  );
};

export default Port3;
